export const ApplicationRoles = {
    Administrator: "Administrator",
    Editor: "Editor",
    Viewer: "Viewer",
}

export const DataChangeType = {
    AddNew: 0,
    Update: 1,
    Delete: 2
}
export const DataUpdateStatus = {
    Ok: 0,
    NoChanges: 1,
    Error: 2
}

export const RowUpdateStatus = {
    Ok: 0,
    Error: 1
}